export default {
  asset: {
    upload: {
      errorType: 'ファイルタイプ {type} はアップロードできません',
      errorFileSize:
        'ファイルサイズが制限を超えており、最大 {size} を超えることはできません',
      errorFileDirection: 'ファイルのアスペクト比が一致しません',
      label: 'クリエイティブアセットをアップロード',
      describe: 'ファイルをドラッグして即時にアップロード',
      rules:
        'ビデオ：mp4/avi/mkv/flv/mov/webm\n画像：jpg/png/gif\n音声：mp3/aac/wav\nその他：psd/zip',
      imageRules: '画像',
      videoRules: 'ビデオ',
      audioRules: '音声',
      otherRules: 'その他',
      selectall: '全選択',
      selected: '選択した {selectNum} アイテム',
      capacity: 'ストレージスペース',
      filetips: 'ファイルが重複しています。名前を変更してください。',
      exists: 'ファイルは既に存在します',
      describing: '{successNum} / {selectNum} ファイルがアップロードされました',
      success:
        '{successNum} 個のファイルがすべて正常にアップロードされました。',
      total:
        '{failNum} 個のファイルがアップロードに失敗し、 {successNum} 個のファイルが正常にアップロードされました。',
      completed: 'アップロード完了',
      failed: 'アップロード失敗',
      fontRules: 'フォント',
    },
    label: 'クリエイティブアセット',
    download: {
      maxDownload: '500Mを超えるファイルのダウンロードは許可されていません',
      filePack: 'ファイルパッキング中',
      fileDownload: 'ファイルダウンロード中',
    },
    rules: {
      nameNoSpecialCharacter: '名前に特殊文字は使用できません',
      nameNoEmpty: '名前は空欄にできません',
      success: '編集成功',
    },
    table: {
      describe:
        '· アセットがプロジェクトで使用されている場合、アセットの削除はプロジェクトの編集に影響します。<br/>· アセットに録画ファイルが含まれる場合、録画ファイルは直接削除できません。録画ファイルを削除するには、関連する録画プロジェクトを削除する必要があります。<br/>· この操作は元に戻せません。削除しますか？',
      name: 'アセット名およびID',
      assetssource: 'ソース',
      assetstype: 'タイプ',
      format: '形式',
      size: 'サイズ',
      updatetime: '更新日',
      batch: {
        delete: {
          label: '削除 {num} アイテムのアセット',
          describe:
            'アセットがプロジェクトで使用されている場合、削除はプロジェクトの編集に影響します。<br/>アセットに録画プロジェクトファイルが含まれる場合、このファイルは直接削除できません。削除するには関連する録画プロジェクトを削除する必要があります。<br/>削除後、元に戻すことはできません。削除してもよろしいですか？',
        },
        download: {
          label: 'ファイルのダウンロード',
          selected: '選択された 2 つのファイル項目',
          total: 'ファイルサイズ合計 {fileSize}',
          forbidTip: '変換に失敗したためダウンロードできません',
        },
      },
      status: '変換ステータス',
      operation: {
        editName: 'アセット名の編集',
        rename: '名前の変更',
        ai: 'AI動画編集',
        video: '動画編集',
        videoDisableTip: 'mp4、mov形式のサポート、サイズ制限は500MB以下。',
      },
    },
    describe:
      'ビデオ/録画/プレイ可能な各種クリエイティブアセットを統合的に管理します。',
    tab: {
      label: 'クリエイティブアセット',
    },
    uploading: 'アップロード中',
    creating: 'アップロード中',
    filter: {
      assetname: 'アセット名',
      assetid: 'アセットID',
      createtime: '作成日',
      updatetime: '更新日',
      size: 'ファイルサイズ',
      format: '形式',
      audio: '音声',
      image: '画像',
      video: 'ビデオ',
      other: 'その他',
      types: 'タイプ',
      h5: 'H5',
      font: 'フォント',
      psd: 'PSD',
      zip: '圧縮ファイル',
      recordfile: '録画プロジェクトファイル',
    },
    advanced: {
      tips: '高度なフィルタリング',
      direction: '方向',
      horizontal: '横',
      vertical: '縦',
      square: '方',
      proportion: '比率',
      duration: '時間',
      second: '秒',
      minute: '分',
      hour: '時間',
      code: 'ビットレート',
      frame: 'フレームレート',
      filesize: 'サイズ',
      size: '寸法',
      date: '日付',
      createdate: '作成日',
      updatedate: '更新日',
      nowadays: '今日',
      last7days: '過去1週間',
    },
    result: '結果',
    gridtips: 'グリッドビュー',
    listtips: 'リストビュー',
    multiple: '複数選択',
    details: {
      message: 'アセットの詳細',
      name: 'アセット名',
      placeholder: 'アセット名を入力してください',
      description: '説明',
      desplaceholder: '説明を入力してください',
      source: '出典',
      type: 'タイプ',
      label: 'ラベル',
      folder: 'フォルダ',
      founder: '作成者',
      lastupdated: '最後の更新者',
      updatedtime: '更新日',
      information: 'ファイル情報',
    },
    transcode: {
      transcoding: '変換中',
      error: '変換に失敗',
      active: '変換成功',
    },
  },
}
